import React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

// Hover tooltip around one child. `show={false}` renders the child alone; other props go to OverlayTrigger.
export default function Tip({text, tooltipId, tooltipClassName, show = true, children, ...triggerProps}) {
    if (!show) return children;
    return (
        <OverlayTrigger
            {...triggerProps}
            overlay={<Tooltip id={tooltipId} className={tooltipClassName}>{text}</Tooltip>}
        >
            {children}
        </OverlayTrigger>
    );
}
